export default {
  title: 'Tienda',
  fields: {
    has_reservations: {
      label: 'Mostrar reservas en la tienda',
    },
  },
  button: {
    save: 'Guardar',
    preview: 'Vista previa',
  },
  no_storefront: {
    title: 'No se encontró ninguna tienda',
    description: 'Por favor, crea una tienda.',
    button: {
      storefront: 'Ir a la tienda',
    },
  },
  response_messages: {
    success: 'Actualizado correctamente.',
    failed: 'Error al actualizar.',
  },
};
